import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import MypageCompleteCard from '../../../uiParts/card/MypageCompleteCard';
import CustomSnackbar from '../../../uiParts/form/CustomSnackbar';
import CustomLoading from '../../../uiParts/form/CustomLoading';
import SideBar from '../../../uiParts/menu/SideBar';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import MetaTitle from '../../../utils/MetaTitle';
import { useAdminPageAccessControl } from '../../../../hooks/useAdminPageAccessControl';
import { AdminNoPermissionPage } from '../../../uiParts/parts/AdminNoPermission';
import { usePageLayout } from '../../../../hooks/usePageLayout';

interface LocationState {
  fromPlanChange?: boolean;
}

const CompanyPlanChangeComplete: React.FC = () => {
  const { companyId } = useParams<{ companyId: string }>();
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const { noPermission, isChecking } = useAdminPageAccessControl('CompanyPlanChangeComplete');
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as LocationState | null;
  const isValidAccess = Boolean(state?.fromPlanChange);
  const { sideBarCollapsed, toggleSidebar, styles: layoutStyles } = usePageLayout();

  useEffect(() => {
    const handlePopState = (): void => {
      setSnackbarOpen(true);
      window.history.pushState(null, '', window.location.href);
    };

    window.history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  useEffect(() => {
    if (isChecking || noPermission) return;

    if (!isValidAccess) {
      navigate(`/admin/company/${companyId}`);
    }
  }, [isChecking, noPermission, isValidAccess, navigate, companyId]);

  if (isChecking) {
    return (
      <>
        <MetaTitle />
        <CustomLoading loading={true} />
      </>
    );
  }

  if (noPermission) {
    return <AdminNoPermissionPage companyId={companyId} />;
  }

  if (!isValidAccess) {
    return null;
  }

  return (
    <Box sx={layoutStyles.pageWrapper}>
      <MetaTitle />
      <Box sx={[layoutStyles.sidebar, sideBarCollapsed && layoutStyles.sidebarCollapsed]}>
        <SideBar collapsed={sideBarCollapsed} onToggle={toggleSidebar} />
      </Box>
      <Box
        sx={[
          layoutStyles.pageContent,
          sideBarCollapsed && layoutStyles.pageContentCollapsed,
          layoutStyles.pageContentNoFooter,
          layoutStyles.fullHeightContent,
          {
            justifyContent: 'center',
            alignItems: 'center',
          },
        ]}
      >
        <MypageCompleteCard
          IconComponent={CheckCircleIcon}
          titleText={'契約プランを変更しました'}
          isMessageCenter
          messageText={''}
          buttonText="企業詳細へ"
          targetPath={`/admin/company/${companyId}`}
        />
      </Box>

      <CustomSnackbar
        open={snackbarOpen}
        onClose={(): void => setSnackbarOpen(false)}
        text=""
        infoText="前のページに戻れません。"
      />
    </Box>
  );
};

export default CompanyPlanChangeComplete;
